var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowlef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0148 0.964285C11.0148 0.883928 10.9746 0.793526 10.9143 0.733259L10.4121 0.231026C10.3518 0.170759 10.2614 0.13058 10.1811 0.13058C10.1007 0.13058 10.0103 0.170759 9.95006 0.231026L6.00251 4.17857L2.05497 0.231026C1.9947 0.170759 1.9043 0.13058 1.82394 0.13058C1.73354 0.13058 1.65318 0.170759 1.59291 0.231026L1.09068 0.733259C1.03041 0.793526 0.990234 0.883928 0.990234 0.964285C0.990234 1.04464 1.03041 1.13504 1.09068 1.19531L5.77148 5.87612C5.83175 5.93638 5.92215 5.97656 6.00251 5.97656C6.08287 5.97656 6.17327 5.93638 6.23354 5.87612L10.9143 1.19531C10.9746 1.13504 11.0148 1.04464 11.0148 0.964285Z",
    fill: "#19352A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlef);
export default __webpack_public_path__ + "static/media/arrowlef.1ee0fcb95ee846c30262677a6058b94d.svg";
export { ForwardRef as ReactComponent };